module.exports = __webpack_public_path__ + "static/media/save.31bb8fd7.svg";